import { render, staticRenderFns } from "./_IconChip.vue?vue&type=template&id=b56c8c8a&"
import script from "./_IconChip.vue?vue&type=script&lang=ts&"
export * from "./_IconChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56c8c8a')) {
      api.createRecord('b56c8c8a', component.options)
    } else {
      api.reload('b56c8c8a', component.options)
    }
    module.hot.accept("./_IconChip.vue?vue&type=template&id=b56c8c8a&", function () {
      api.rerender('b56c8c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/PowerbarNav/_IconChip.vue"
export default component.exports